module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-ext_latin-600.ba13b15f.woff2";